/** @format */

import {Box, Typography} from '@mui/material';
import {Theme} from '@mui/material/styles';
import {makeStyles, createStyles} from '@mui/styles';
import {Trans} from 'react-i18next';

import JuliaBot from 'components/managers/JuliaBot';
import Anna from 'components/managers/Anna';
import {IsRuVersion} from 'helpers/routerHelpers';

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    body: {
      fontSize: 22,
      fontWeight: 700,
      lineHeight: '27px',
    },
  }),
);

const Manager = () => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.body}>
        <Trans>Для продолжения работы с AdSensor напишите вашему персональному менеджеру</Trans>
      </Typography>

      <Box mt={8}>
        {IsRuVersion() && <JuliaBot />}
        {!IsRuVersion() && <Anna />}
      </Box>
    </>
  );
};

export default Manager;
